module.exports = __webpack_public_path__ + "img/caiji-type-1-2.c6bd3ed3.png";